import { ORDER_TYPE } from 'constants/trading';

const buyPreviewTitle = 'Buy Order Preview';
const sellPreviewTitle = 'Sell Order Preview';

export const defaultPreviewModalTitle = 'Order Preview';

export const previewModalTitle: Record<keyof typeof ORDER_TYPE, string> = {
  BUY: buyPreviewTitle,
  AMEND_BUY: buyPreviewTitle,
  VIRTUAL_BUY: buyPreviewTitle,
  VIRTUAL_AMEND_BUY: buyPreviewTitle,
  SELL: sellPreviewTitle,
  VIRTUAL_SELL: sellPreviewTitle,
  AMEND_SELL: sellPreviewTitle,
  VIRTUAL_AMEND_SELL: sellPreviewTitle,
  EXERCISE: defaultPreviewModalTitle,
  BOND: defaultPreviewModalTitle,
};
